
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { CreateTechniqueFormValues } from './FormSchema';

interface CommonMistakesFieldProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const CommonMistakesField: React.FC<CommonMistakesFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="commonMistakes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Common Mistakes*</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Enter common mistakes separated by commas (e.g., Overextending, Losing posture, Applying too much force)"
              className="min-h-[80px]" 
              {...field}
            />
          </FormControl>
          <FormDescription>
            Enter common mistakes when performing this technique, separated by commas
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
